import React from 'react'
import {CustomModal} from '../../../common'
import {i18n} from '../../../../i18n'
import MedicationOrder from "../subcomponents/MedicationOrder"

const MedicationOrderModal: React.FC<MedicationOrderModalProps> = ({
                                                                       visible,
                                                                       onClose,
                                                                   }) => {
    return (
        <CustomModal
            title={i18n.t('therapyTab.actions.orderSummaryTitle')}
            open={visible}
            width={'800px'}
            onCancel={onClose}
        >
            <MedicationOrder
                onCloseModal={onClose}
            />
        </CustomModal>
    )
}

type MedicationOrderModalProps = {
    visible: boolean
    onClose: () => void
}

export default MedicationOrderModal